/**
 * App - Hero banner wizard'in tum bilesenlerini bir araya getirir.
 *
 *  - TireFilterStore: Shopify metafield filtre degerlerini fetch + cache eder.
 *  - TireWizard:      Adim adim kullaniciya degerleri sunar (cascading).
 *  - Season tabs:     Wizard'a "ust filtre" olarak gecirilir; degisirse cache
 *                     temizlenir, mevcut secimler reset edilir ve aktif adim yeniden cizilir.
 */

document.addEventListener('DOMContentLoaded', () => {
  const activeTabEl = document.querySelector('.season-tab.active');
  let selectedSeason = (activeTabEl && activeTabEl.dataset.season) || 'All Season';

  const diagram = new TireDiagram('tireDiagram');

  // Debug log'lari default acik. Kapatmak icin: window.HERO_BANNER_DEBUG = false (load oncesi).
  const heroDebug = window.HERO_BANNER_DEBUG !== false;

  const store = (typeof TireFilterStore === 'function')
    ? new TireFilterStore({
        collectionHandle: 'tires',
        viewName: 'tire-filter-data',
        debug: heroDebug,
      })
    : null;

  if (store) {
    window.__tireFilterStore = store;
  }

  // ═══ Reifenwechsel Toggle - localStorage Persist ═══
  const REIFENWECHSEL_KEY = 'acs_reifenwechsel_enabled';
  const reifenwechselToggle = document.getElementById('reifenwechselToggle');
  
  if (reifenwechselToggle) {
    // Kayıtlı değeri yükle (varsayılan: true)
    const savedValue = localStorage.getItem(REIFENWECHSEL_KEY);
    if (savedValue !== null) {
      reifenwechselToggle.checked = savedValue === 'true';
    } else {
      // İlk ziyarette varsayılan olarak açık
      reifenwechselToggle.checked = true;
      localStorage.setItem(REIFENWECHSEL_KEY, 'true');
    }
    
    // Değişikliği kaydet
    reifenwechselToggle.addEventListener('change', () => {
      localStorage.setItem(REIFENWECHSEL_KEY, reifenwechselToggle.checked.toString());
      console.log('[Reifenwechsel]', reifenwechselToggle.checked ? 'enabled' : 'disabled');
    });
  }

  const wizard = new TireWizard({
    filterBarId: 'filterBar',
    popoverId:   'wizardPopover',
    diagram,
    store,
    getSeason: () => selectedSeason,
    onComplete: () => {
      document.getElementById('findBtn').classList.add('ready');
    },
    onStepChange: (step) => {
      diagram.setActiveStep(step);
    },
  });

  const seasonTabs = document.querySelectorAll('.season-tab');
  seasonTabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const newSeason = tab.dataset.season;
      if (newSeason === selectedSeason) return;

      seasonTabs.forEach((t) => t.classList.remove('active'));
      tab.classList.add('active');
      selectedSeason = newSeason;

      const wasOpen = wizard.isOpen;

      if (store) store.invalidate();

      wizard.reset();

      if (wasOpen) {
        wizard.open();
      }
    });
  });

  document.getElementById('findBtn').addEventListener('click', () => {
    const selections = wizard.getSelections();

    const params = new URLSearchParams();

    TIRE_DATA.steps.forEach((step) => {
      if (selections[step.key] !== undefined) {
        params.set(step.paramName, selections[step.key]);
      }
    });

    params.set('filter.v.m.tire.season', selectedSeason);

    const url = `/collections/tires?${params.toString()}`;

    console.log('🔗 Generated URL:', url);

    const preview = document.getElementById('urlPreview');
    if (preview) {
      preview.textContent = url;
      preview.classList.add('visible');
    }

    window.location.href = url;
  });

  document.getElementById('filterBar').addEventListener('click', () => {
    if (!wizard.isOpen) {
      wizard.open();
    }
  }, { once: true });
});
